import { useCallback, useState } from 'react';
import { useBookmarkItems } from '../general/bookmark-selection';
import { ContentPage } from '../components/content-page';
import { GetUserSessionEventsApiResponseDto, SessionEventDto, SessionSearchDto } from '../general/dtos';
import { ActivitiesDataProvider } from '../providers/activities-provider';
import { ActivityList } from '../components/activity-list';
import { ActivityDetails } from '../components/activity-details';
import { Api } from '../general/api';
import { GeneralErrorDialog } from '../components/dialogs/error-dialog';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { AxiosError } from 'axios';
import { useApi } from '../providers/api-provider';

export default function ActivitiesPage() {
    const api: Api = useApi();
    
    const loadSession = useCallback((key: string) => api.getSession(key), [api]);
    const { items: bookmarkedSessions, setItems: setBookmarkedSessions, error: bookmarkError } = useBookmarkItems<SessionSearchDto>('session', api ? loadSession : null, sessionKey);
    const selectedSession = bookmarkedSessions[0] ?? null;
    const setSelectedSession = (session: SessionSearchDto) => setBookmarkedSessions(session ? [session] : []);
    const [error, setError] = useState<string>('');
    const [errorTitle, setErrorTitle] = useState<string>('');
    const [errorDetails, setErrorDetails] = useState<string>('');

    const loadUserSessionEvents = async (sub: string, sessionId: string): Promise<SessionEventDto[]> => {
        try {
            const json: GetUserSessionEventsApiResponseDto | null = await api.getUserSessionEvents(sub, sessionId);
            return json?.data ?? [];
        } catch (error: AxiosError | any) {
            const message: string = error.response?.data?.message ?? 'Load error';
            setError(message);
            setErrorTitle('Error loading session events');
            setErrorDetails('There was an unhandled error while trying to load the user session events. Please try again later or contact support :)');
        }
        return [];
    }
    
    return (
        <ActivitiesDataProvider>
            {bookmarkError && <p role="alert">{bookmarkError}</p>}
            <div style={{ flex: 1, display: 'flex', minHeight: 0, width: '100%', minWidth: '0'/*, backgroundColor: 'blue'*/ }}>
                <ContentPage
                    pageId="activities"
                    pageTitle="User activities"
                    leftPanelTitle="User sessions"
                    rightPanelTitle="Selected session details"
                    leftContent={<ActivityList selectedSession={selectedSession} onSelectionChange={setSelectedSession} />}
                    rightContent={<ActivityDetails selectedSession={selectedSession} loadEvents={loadUserSessionEvents}/>}
                />
            </div>

            <GeneralErrorDialog
                visible={error.length > 0}
                title={errorTitle}
                message={error}
                details={errorDetails}
                onClose={() => setError('')}
            />
        </ActivitiesDataProvider>
        );
}

const sessionKey = (session: SessionSearchDto) => session.session_id;
